import {memo} from 'react';

import styled from 'styled-components';
import {useSelector} from 'react-redux';

import {brandName, isJustEat} from '~/shared/config';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import orangeSmLogoUrl from '~/assets/images/orange-sm-logo.svg';
import orangeLgLogoUrl from '~/assets/images/tenBis-logo.svg';
import orangeMdLogoUrl from '~/assets/images/tenBis-logo-md.svg';
import jeOrangeLgLogoUrl from '~/assets/images/je-orange-lg-logo.svg';
import jeOrangeMobileLogoUrl from '~/assets/images/just-eat-mobile-logo.svg';
import govOrangeLgLogoUrl from '~/assets/images/gov-orange-lg-logo.svg';
import {getLocalizationService} from '~/shared/services/localisationService';
import {selectIsGovCompanyUser} from '~/shared/store/selectors';
import {useIsMinLargeMobile, useIsMinLargeTablet} from '~/shared/hooks/deviceInfo';
import {Link} from '~/shared/router';
import {defaultStartPage} from '~/shared/services/navigation';
import {media} from '~/shared/theme/media';

const SharedLogoCss = styled(ImageWithAlt)`
  cursor: pointer;
`;

const SmOrangeLogo = styled(SharedLogoCss).attrs({
  src: orangeSmLogoUrl,
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
})``;

const MdOrangeLogo = styled(SharedLogoCss).attrs({
  src: orangeMdLogoUrl,
  width: 35,
  height: 40,
  viewBox: '0 0 35 40',
})``;

const LgOrangeLogo = styled(SharedLogoCss).attrs({
  src: orangeLgLogoUrl,
  width: 118,
  height: 32,
  viewBox: '0 0 118 32',
})``;

const JeOrangeLogo = styled(SharedLogoCss).attrs({
  src: jeOrangeLgLogoUrl,
})`
  width: 100px;
  height: 16px;
  ${media.minLargeMobile`
    width: 146px;
    height: 24px;
  `}
`;

const JeOrangeMobileLogo = styled(SharedLogoCss).attrs({
  src: jeOrangeMobileLogoUrl,
})`
  width: 32px;
  height: 32px;
`;

const GovLgOrangeLogo = styled(SharedLogoCss).attrs({
  src: govOrangeLgLogoUrl,
  width: 116,
  height: 44,
  viewBox: '0 0 116 44',
})``;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const Logo = ({isHardLogoClick}: {isHardLogoClick: boolean}) => {
  const {t} = getLocalizationService();
  const startPageLink = defaultStartPage();

  const isMinLargeMobile = useIsMinLargeMobile();
  const isMinLargeTablet = useIsMinLargeTablet();

  const isGovCompanyUser = useSelector(selectIsGovCompanyUser);

  if (isJustEat) {
    const LogoComponent = !isMinLargeMobile ? JeOrangeMobileLogo : JeOrangeLogo;

    return (
      <StyledLink data-id="main-header-logo" href={startPageLink} hard={isHardLogoClick}>
        <LogoComponent alt={brandName} />
      </StyledLink>
    );
  }

  return (
    <StyledLink data-id="main-header-logo" href={startPageLink} hard={isHardLogoClick}>
      {isGovCompanyUser && isMinLargeTablet ? (<GovLgOrangeLogo alt={t('10bis')}/>) : (
        <>
          {!isMinLargeMobile && !isMinLargeTablet && <SmOrangeLogo alt={t('10bis')} />}
          {isMinLargeMobile && !isMinLargeTablet && <MdOrangeLogo alt={t('10bis')} />}
          {isMinLargeTablet && <LgOrangeLogo alt={t('10bis')} />}
        </>
      )}
    </StyledLink>
  );
};

export default memo(Logo);
